import { useState } from 'react';
import { Col, Row, Container, Button, Typography } from 'darrius';

import { type TBadge } from '../../../modules/profile/shared/@interfaces';

import styles from './ProfileBadges.module.scss';
import { Dialog } from '../../../components';

interface IProfileBadgesProps {
  badges: TBadge[];
}

export const ProfileBadges = ({ badges }: IProfileBadgesProps) => {
  const [showBadgeModal, setShowBadgeModal] = useState<TBadge | null>(null);

  if (!badges) {
    return null;
  }

  const handleOnClick = (badge: TBadge) => {
    setShowBadgeModal(badge);
  };

  function handleCloseModal() {
    setShowBadgeModal(null);
  }

  const SECTION_TITLE = 'Conquistas';

  const SafeHTML = ({ html }) => (
    <div dangerouslySetInnerHTML={{ __html: html }} />
  );

  return (
    <section className={`${styles.section} `} id="achievements">
      <Row>
        <Col className="col-sm-12">
          <Typography.Subtitle
            size="l"
            className={styles['profile-badge__title']}
          >
            {SECTION_TITLE}
          </Typography.Subtitle>
        </Col>

        {badges !== null && (
          <Row className={`${styles.full} ${styles['profile-badge']}`}>
            {badges.map((badge) => (
              <>
                <Col
                  key={badge.title}
                  className="col-sm-4 col-md-4 col-lg-3 center-sm"
                >
                  <div onClick={() => handleOnClick(badge)}>
                    <img
                      src={badge.image}
                      alt={badge.title}
                      width="72"
                      height="72"
                    />

                    <Typography.Text className={styles['badges__title-item']}>
                      {badge.title}
                    </Typography.Text>

                    <Button.Root
                      className={styles['text-link']}
                      variation="clear"
                      fullWidth
                    >
                      <span>Saiba mais</span>
                    </Button.Root>
                  </div>
                </Col>
              </>
            ))}
          </Row>
        )}

        {showBadgeModal !== null && (
          <Dialog.Root
            open={showBadgeModal !== null}
            onOpenChange={handleCloseModal}
          >
            <Dialog.Portal>
              <Dialog.Content className={styles['badge-modal']}>
                <Container className={`container ${styles.container}`}>
                  <Row className="space-bottom">
                    <Dialog.Close className={`${styles.close}`} />
                  </Row>
                  <Row className={`modal center-sm ${styles['modal-body']}`}>
                    <Col className="col-sm-12">
                      <img
                        src={showBadgeModal.image}
                        alt={showBadgeModal.title}
                        width="72"
                        height="72"
                      />
                    </Col>

                    <Col className="col-sm-12">
                      <Typography.Subtitle
                        size="xl"
                        className={styles['profile-badge__title-modal']}
                      >
                        {showBadgeModal.title}
                      </Typography.Subtitle>
                    </Col>

                    <Col className="col-sm-12">
                      <Typography.Text className={styles['modal-text']}>
                        <SafeHTML html={`${showBadgeModal.text}<br><br>`} />
                      </Typography.Text>
                    </Col>

                    <Col className="col-sm-12">
                      <Button.Root onClick={handleCloseModal} fullWidth>
                        Entendi
                      </Button.Root>
                    </Col>
                  </Row>
                </Container>
              </Dialog.Content>
            </Dialog.Portal>
          </Dialog.Root>
        )}
      </Row>
    </section>
  );
};
